import { Component, EventEmitter, Input, Output, SimpleChanges } from '@angular/core';

export interface NavbarStepsInfo {
  Title: string;
  Id: number;
  Active?: boolean;
  Completed?: boolean
}

@Component({
  selector: 'app-horizontal-navbar',
  templateUrl: './horizontal-navbar.component.html',
  styleUrls: ['./horizontal-navbar.component.scss']
})
export class HorizontalNavbarComponent {

  /*
   example: 
   navbarSteps = [
    { Title: this.TranslateService.instant('EDIT_SERVICES.HEADER.5'), Id: 1 },
    { Title: this.TranslateService.instant('EDIT_SERVICES.HEADER.6'), Id: 2 },
    { Title: this.TranslateService.instant('EDIT_SERVICES.HEADER.7'), Id: 3 },
    { Title: this.TranslateService.instant('EDIT_SERVICES.HEADER.8'), Id: 4 },

  */

  @Input() NavbarSteps: NavbarStepsInfo[] = [];
  @Input() CurrentStepId: number = 1;
  @Input() EnableNextStep: boolean = true;

  @Output() stepEmitter = new EventEmitter<number>();

  ngOnChanges(changes: SimpleChanges) {
    if (changes && changes['CurrentStepId']) {
      this.updateNavbarSteps();
    }
  }

  async setStep(stepId: number) {
    if (stepId > this.CurrentStepId && !this.EnableNextStep) { return }
    this.CurrentStepId = stepId
    this.emitCurrentStep();
    this.updateNavbarSteps();
  }

  emitCurrentStep() {
    this.stepEmitter.emit(this.CurrentStepId);
  }

  updateNavbarSteps() {
    this.NavbarSteps = this.NavbarSteps.map((step: NavbarStepsInfo) => ({
      ...step,
      Active: step.Id === this.CurrentStepId,
      Completed: step.Id < this.CurrentStepId,
    }));
  }
}
